import React, { useState, useEffect } from 'react';
import useBodyScrollLock from '../../hooks/useBodyScrollLock';
import api from '../../utils/api';
import { userFacingDetail } from '../../utils/errorHandler';

const CreateJobModal = ({
    isOpen,
    onClose,
    opportunityId,
    onSuccess
}) => {
    const [newJobCompanyName, setNewJobCompanyName] = useState('');
    const [jobModalLoading, setJobModalLoading] = useState(false);
    const [jobModalError, setJobModalError] = useState(null);

    useBodyScrollLock(isOpen);

    // モーダルが開かれた時に初期値を設定
    useEffect(() => {
        if (isOpen) {
            setNewJobCompanyName('');
            setJobModalError(null);
        }
    }, [isOpen]);

    const handleCreateJob = async (event) => {
        event.preventDefault();
        if (!newJobCompanyName.trim()) {
            setJobModalError('企業名は必須です。');
            return;
        }
        setJobModalLoading(true);
        setJobModalError(null);
        try {
            const response = await api.fetch(`/proposed_jobs/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    company_name: newJobCompanyName,
                    job_description: '',
                    memo: '',
                    opportunity_id: opportunityId,
                }),
            });
            if (!response) return; // Redirected
            if (!response.ok) {
                const errorData = await response.json().catch(() => null);
                throw new Error(userFacingDetail(response.status, errorData) || '作成に失敗しました。');
            }
            const newJob = await response.json();
            setJobModalLoading(false);
            
            if (onSuccess) {
                onSuccess(newJob);
            }
            onClose();
        } catch (err) {
            setJobModalLoading(false);
            setJobModalError(err.message);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <form onSubmit={handleCreateJob}>
                    <h3 className="modal-title">新規求人提案</h3>
                    <div className="form-group">
                        <label htmlFor="jobCompanyName">企業名 *</label>
                        <input
                            id="jobCompanyName" type="text" value={newJobCompanyName}
                            onChange={(e) => setNewJobCompanyName(e.target.value)}
                            disabled={jobModalLoading}
                            placeholder="例: 株式会社サンプル"
                            autoFocus
                        />
                    </div>
                    {jobModalError && (
                        <p className="modal-error-message">{jobModalError}</p>
                    )}
                    <div className="modal-actions">
                        <button
                            type="button" className="modal-button-cancel"
                            onClick={onClose} disabled={jobModalLoading}
                        >
                            キャンセル
                        </button>
                        <button
                            type="submit" className="modal-button-confirm"
                            disabled={jobModalLoading}
                        >
                            {jobModalLoading ? '作成中...' : '追加'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CreateJobModal;
